import api from '../../utils/api'

const state = {
  keys: {}
}

const getters = {
  getKeys (state) {
    return state.keys
  }
}

const actions = {
  getKeys ({ commit }, payload) {
    return api('/api/keys', 'GET', payload)
  },
  getMachineIds ({ commit }, payload) {
    return api('/api/machineids', 'GET', payload)
  },
  getActivationkey ({ commit }, payload) {
    return api('/api/activationkey', 'POST', payload)
  }
}

const mutations = {
}

export default {
  state,
  mutations,
  getters,
  actions
}
